import { configureStore } from '@reduxjs/toolkit';
import faqsReducer from '../features/FAQ/controller';
import sessionReducer from '../Components/Header/controller';
import loginReducer from '../features/Login/controller';
import otpReducer from '../features/Otp/controller';
import requestsReducer from '../features/Requests/controller';
import requestDetailsReducer from '../features/RequestDetails/controller';
import paymentDetailsReducer from '../features/Invoices/controller';
import marriageFormReducer from '../features/Marriage/Form/controller';
import marriageSummaryReducer from '../features/Marriage/Summary/controller';
import schoolFormReducer from '../features/School/Form/controller';
import schoolSummaryReducer from '../features/School/Summary/controller';
import archivalFormReducer from '../features/Archival/Form/controller';
import archivalSummaryReducer from '../features/Archival/Summary/controller';
import cartReducer from '../features/Cart/controller';
import logoutReducer from '../features/Logout/controller';
import { antiForgeryCheckingMiddleware } from './middleware';

export const store = configureStore({
  reducer: {
    Session: sessionReducer,
    login: loginReducer,
    faqs: faqsReducer,
    otp: otpReducer,
    requests: requestsReducer,
    requestDetails: requestDetailsReducer,
    paymentDetails: paymentDetailsReducer,
    marriageForm: marriageFormReducer,
    marriageSummary: marriageSummaryReducer,
    schoolForm: schoolFormReducer,
    schoolSummary: schoolSummaryReducer,
    archivalForm: archivalFormReducer,
    archivalSummary: archivalSummaryReducer,
    cart: cartReducer,
    logout: logoutReducer
  },
  // middleware: (getDefaultMiddleware) =>
  // getDefaultMiddleware().concat(antiForgeryCheckingMiddleware),
});
